import { MemberRepresentationDto } from "@api/user-app-service";

const SERVICE_ACCOUNT_USERNAME_PREFIX = "service-account-";

export function isM2mUser(admin: MemberRepresentationDto, m2mClientIds: ReadonlySet<string>): boolean {
  const username = admin.username;
  if (!username?.startsWith(SERVICE_ACCOUNT_USERNAME_PREFIX)) {
    return false;
  }

  const clientId = username.slice(SERVICE_ACCOUNT_USERNAME_PREFIX.length);
  return !!clientId && m2mClientIds.has(clientId);
}
